import api from ".";
import cookiesModifier from "../utils/cookies";

import { IProgram } from "../types/program";

export const getAllPrograms = async (applicantId: number) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.get(`applicant-programs/applicant/${applicantId}`);
        return res.data.data as IProgram[];
    } catch (error) {
        throw error;
    }
}